 <template>
 <div class="photo-edit-form">

  <v-container>
    <v-row align="center">
    <v-col cols="12">
    <h3>{{ image.title }}</h3>
    <br />
    <img :src="image.display" />
    <br />
    <h3> love: {{ image.votes_count }} </h3>
    <br />
    <strong>{{ image.title }}</strong> by <span v-if="username == image.user">me</span><span v-else>
    <router-link :to="{ name: 'user-gallery', params: { id: image.user }}">{{ image.user }}</router-link>
    </span><br />
    {{ image.description }}
    </v-col>
    </v-row>
    <v-row>
  
    <v-col cols="8">
        <Exif :items="exif"/>
    </v-col>
    <v-col cols="4">
        <Curation />
    </v-col>
    </v-row>
     <v-row align="center" no-gutter>      
        <GroupItem
            type="collective"
            :groups="image.collectives"
        />
        <GroupItem
            type="project"
            :groups="image.projects"
        />
        <GroupItem
            type="competition"
            :groups="image.competitions"
        />
        <GroupItem
            type="workshop"
            :groups="image.workshops"
        />     
     </v-row>
  </v-container>
 </div>
</template>

<script>

import Icons from '@/components/gallery/Icons'
import GroupItem from '@/components/group/Item'
import Curation from '@/components/image/Curation'
import Exif from '@/components/image/Exif'
import { userMixin, imageMixin } from '@/functions/mixins'


export default { 
        name: 'PhotoSingle',
        components: { 
            Icons,
            GroupItem,
            Curation,
            Exif
        },
        mixins: [userMixin, imageMixin],
        data() {
            return {
                loading: true,
                image_id: this.$route.params.image_id
            }
        },
        computed: {
            image() {
                return this.filteredById(this.image_id)
            },
            exif() {
                let exif = this.image.exif.replace(/'/g, '"');
                try {
                    JSON.parse(exif)
                    return JSON.parse(exif)
                } catch (e) {
                    return {}
                }    
            }
        },
        watch: {
            '$route' () {
                if(this.$route.params.image_id) {
                    this.image_id = this.$route.params.image_id
                }  
            },
            image () {
                if(this.loading) {
                    this.loading=false
                }
            }
        }
    }
</script>s

<style scoped>
.editform {
  padding-top: 50px;
}

.save {margin: 20px;}

.collectives {
    background-color: yellow !important;
}
</style>